module.exports = __webpack_public_path__ + "img/bg-lg-2ft.b7f856df.jpg";